import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxsModule } from '@ngxs/store';
import { AuthInterceptor } from './services/http-interceptor.service';
import { environment } from 'src/environments/environment';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import {
	GoogleLoginProvider,
	SocialLoginModule,
	SocialAuthServiceConfig,
	FacebookLoginProvider,
	MicrosoftLoginProvider,
	GoogleSigninButtonModule
} from '@abacritt/angularx-social-login';
import { SharerMethod } from 'ngx-sharebuttons';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';

import {
	MsalGuard,
	MsalInterceptor,
	MsalBroadcastService,
	MsalService,
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalRedirectComponent
} from '@azure/msal-angular';

import { MSALGuardConfigFactory } from '../identity/msal.guard';
import { MSALInstanceFactory } from '../identity/msal.instance';
import { MSALInterceptorConfigFactory } from '../identity/msal.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N, en_US, NzI18nModule } from 'ng-zorro-antd/i18n';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LoginComponent } from './shared/login/login.component';
import { RegistrationComponent } from './shared/registration/registration.component';
import { LanderComponent } from './lander/lander.component';
import { HeroComponent } from './lander/hero/hero.component';
import { JobListingComponent } from './lander/job-listing/job-listing.component';
import { CategoriesComponent } from './lander/categories/categories.component';
import { VideoHolderComponent } from './lander/video-holder/video-holder.component';
import { CareersLifeComponent } from './lander/careers-life/careers-life.component';
import { RecruitTipsComponent } from './lander/recruit-tips/recruit-tips.component';
import { JobListComponent } from './job-list/job-list.component';
import { JobSearchComponent } from './job-list/job-search/job-search.component';
import { JobSidebarComponent } from './job-list/job-sidebar/job-sidebar.component';
import { JobContentComponent } from './job-list/job-content/job-content.component';
import { JobCardComponent } from './shared/job-card/job-card.component';
import { AdvanceFilterComponent } from './shared/advance-filter/advance-filter.component';
import { RegistrationMoreComponent } from './shared/registration-more/registration-more.component';
import { RegistrationOption2Component } from './shared/registration-option2/registration-option2.component';
import { GenericState } from '../app/store/generic.state';
import { LaunchDarklyState } from '../app/store/launch-darkly/launch-darkly.state';
import { JobListState } from '../app/store/job-list/job-list.state';
import { JobPreviewComponent } from './job-preview/job-preview.component';
import { LandingState } from '../app/store/landing/landing.state';
import { SavedJobsComponent } from './my-jobs/saved-jobs/saved-jobs.component';
import { ApplicationsComponent } from './my-jobs/applications/applications.component';
import { ReferralsComponent } from './my-jobs/referrals/referrals.component';
import { ApplicationsState } from './store/applications/applications.state';
import { SavedJobsState } from './store/saved-jobs/saved-jobs.state';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CandidatePersonalDetailsState } from './store/candidate-profile/candidate-personal-details/candidate-personal-details.state';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { ReferralState } from './store/referral/referral.state';
registerLocaleData(en);
import './services/sanitize-text.service';
import { JobAlertState } from './store/job-alert/job-alert.state';
import { JobAlertComponent } from './shared/modal/job-alert/job-alert.component';
import { JobAlertFormComponent } from './shared/modal/job-alert/job-alert-form/job-alert-form.component';
import { AuthState } from './store/auth/auth.state';
import { ResumeQuickLinkComponent } from './resume-quick-link/resume-quick-link.component';
import { SidebarComponent } from './resume-quick-link/sidebar/sidebar.component';
import { ContentHeaderComponent } from './resume-quick-link/content-header/content-header.component';
import { AcademicComponent } from './resume-quick-link/academic/academic.component';
import { ExperienceComponent } from './resume-quick-link/experience/experience.component';
import { SkillsComponent } from './resume-quick-link/skills/skills.component';
import { ApplicationHistoryComponent } from './resume-quick-link/application-history/application-history.component';
import { NotVerifiedComponent } from './shared/modal/not-verified/not-verified.component';
import { CarouselSuggestedJrsComponent } from './shared/carousel-suggested-jrs/carousel-suggested-jrs.component';
import { IpDetectorState } from './store/ip-detector/ip-detector.state';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { QrReferralComponent } from './shared/modal/qr-referral/qr-referral.component';
import { SignupQuestionsComponent } from './signup-questions/signup-questions.component';
import {FirstStepComponent} from "./signup-questions/first-step/first-step.component";
import {SecondStepComponent} from "./signup-questions/second-step/second-step.component";
import {ThirdStepComponent} from "./signup-questions/third-step/third-step.component";
import {FourthStepComponent} from "./signup-questions/fourth-step/fourth-step.component";
@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent, MsalRedirectComponent],
    imports: [
        NzI18nModule,
        NzModalModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgxsModule.forRoot([
            LaunchDarklyState,
            GenericState,
            JobListState,
            LandingState,
            ApplicationsState,
            SavedJobsState,
            CandidatePersonalDetailsState,
            ReferralState,
            JobAlertState,
            AuthState,
            IpDetectorState
        ]),
        environment.NgxsPlugins,
        InfiniteScrollDirective,
        NgxUiLoaderModule,
        SocialLoginModule,
        GoogleSigninButtonModule,
        ShareButtonsModule.withConfig({
            debug: true,
            sharerMethod: SharerMethod.Window
        }),
        ShareIconsModule,
        CarouselModule,
        HeaderComponent,
        FooterComponent,
        LoginComponent,
        LanderComponent,
        RegistrationComponent,
        HeroComponent,
        JobListingComponent,
        CategoriesComponent,
        VideoHolderComponent,
        CareersLifeComponent,
        RecruitTipsComponent,
        JobListComponent,
        JobSearchComponent,
        JobSidebarComponent,
        JobContentComponent,
        JobCardComponent,
        AdvanceFilterComponent,
        RegistrationMoreComponent,
        RegistrationOption2Component,
        JobPreviewComponent,
        SavedJobsComponent,
        ApplicationsComponent,
        ReferralsComponent,
        ResetPasswordComponent,
        PrivacyPolicyComponent,
        TermsOfServiceComponent,
        JobAlertComponent,
        JobAlertFormComponent,
        ResumeQuickLinkComponent,
        SidebarComponent,
        ContentHeaderComponent,
        AcademicComponent,
        ExperienceComponent,
        SkillsComponent,
        ApplicationHistoryComponent,
        NotVerifiedComponent,
        CarouselSuggestedJrsComponent,
        QrReferralComponent,
        SignupQuestionsComponent,
        FirstStepComponent,
        SecondStepComponent,
        ThirdStepComponent,
        FourthStepComponent,
    ],
    providers: [
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                lang: 'en',
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(environment.googleAppProvider, {
                            oneTapEnabled: false,
                            prompt: 'consent'
                        })
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider('1754683755043094')
                    },
                    {
                        id: MicrosoftLoginProvider.PROVIDER_ID,
                        provider: new MicrosoftLoginProvider('43c41737-f690-405d-a7c1-3ade61c086b0')
                    }
                ],
                onError: (error: any) => {
                    console.error(error);
                }
            } as SocialAuthServiceConfig
        },
        { provide: NZ_I18N, useValue: en_US },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
